<template>
  <div class="redirect"></div>
</template>

<script>
export default {
  name: "Redirect",
  data() {
    return {};
  },
  created() {
    // console.log("redirect", this.$route);
    this.$router.replace(this.$route.query.target);
  },

  methods: {},
};
</script>
<style scoped lang="scss">
</style>

